module.exports = __webpack_public_path__ + "fonts/brandon-regular.60bdf60.ttf";